import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import CarrierDTO from '../../../../dto/CarrierDTO';
import { GENDER_OPTIONS, USER_TYPE, USER_TYPE_LIST } from '../../../../configs';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import { companyNameTransform } from '../../../../utils/utils';

export default function CarrierForm(props) {
  const {
    legalEntityType, control,
  } = props;
  const dto = new CarrierDTO();

  const attributes = dto.getAttributesByName();
  return (
    (
      <>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.carrier_type}
            variant="material"
            withLabel
            options={USER_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.carrier_external_id}
            variant="material"
          />
        </Row>
        {legalEntityType === USER_TYPE.LEGAL ? (
          <>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_legal_entity_form}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_short_name}
                variant="material"
              />
            </Row>
            {/* <Row className="row-cols-3"> */}
            {/*  <FieldDTOWithCol */}
            {/*    control={control} */}
            {/*    type="text" */}
            {/*    component={TextInputWithLabel} */}
            {/*    dtoObject={attributes.carrier_last_name} */}
            {/*    variant="material" */}
            {/*  /> */}
            {/*  <FieldDTOWithCol */}
            {/*    control={control} */}
            {/*    type="text" */}
            {/*    component={TextInputWithLabel} */}
            {/*    dtoObject={attributes.carrier_first_name} */}
            {/*    variant="material" */}
            {/*  /> */}
            {/*  <FieldDTOWithCol */}
            {/*    control={control} */}
            {/*    type="text" */}
            {/*    component={TextInputWithLabel} */}
            {/*    dtoObject={attributes.carrier_middle_name} */}
            {/*    variant="material" */}
            {/*  /> */}
            {/* </Row> */}
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_address}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_ur_address}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_inn}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_ogrn}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_full_name}
                transform={companyNameTransform}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_supervisor_last_name}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_supervisor_first_name}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_supervisor_middle_name}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_phone}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_email}
                variant="material"
              />
            </Row>
          </>
        ) : (
          <>
            <Row className={legalEntityType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? 'row-cols-2' : 'row-cols-1'}>
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_inn}
                variant="material"
              />
              {legalEntityType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR && (
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_ogrn}
                variant="material"
              />
              )}
            </Row>
            <Row className="row-cols-3">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_last_name}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_first_name}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_middle_name}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={DateTimePicker}
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                dtoObject={attributes.carrier_birth_date}
                variant="material"
                withLabel
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_birth_place}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={CustomSelectInput}
                dtoObject={attributes.carrier_gender}
                variant="material"
                withLabel
                options={GENDER_OPTIONS}
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_citizenship}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_snils}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_reg_type}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_phone}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_email}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_identity_type}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={DateTimePicker}
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                withLabel
                dtoObject={attributes.carrier_identity_issue_date}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_identity_series}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_identity_number}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_identity_issuer_code}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_criminal_record}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_identity_issuer}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.carrier_address}
                variant="material"
              />
            </Row>
          </>
        )}
      </>
    )
  );
}
